/* ======================================================================
   Cart Page Upsells - Complete Your Bundle
   Shows snack upsells on cart page when bundle items are present
   ====================================================================== */

(function() {
  'use strict';

  // Helper functions
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Configuration
  const UPSELL_PRODUCTS = [
    { title: 'Crunchy Mung Snack - Salted', badge: '⭐ 30% of customers add this' },
    { title: 'Crunchy Mung Snack - Spiced', badge: '🔥 Trending' },
    { title: 'Popped Water Lily Seeds - Salted', badge: '✨ Customer Favorite' },
    { title: 'Popped Water Lily Seeds - Cheddar Cheese', badge: '🧀 Popular Choice' },
    { title: 'Popped Water Lily Seeds - Tangy Tomato', badge: '🍅 Flavor Favorite' }
  ];

  // Toast notification
  function showToast(msg) {
    const existing = document.querySelector('.tlh-cart-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'tlh-cart-toast';
    toast.textContent = msg;
    toast.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #000;
      color: #fff;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      font-weight: 600;
      z-index: 10000;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  // Check if we're on cart page and if bundle items exist
  async function shouldShowUpsells() {
    // Check if we're on cart page
    if (!window.location.pathname.includes('/cart')) {
      return false;
    }

    try {
      // Fetch cart
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Check if any items have bundle properties
      const hasBundleItems = cart.items.some(item =>
        item.properties && item.properties['_bundle_id']
      );

      return hasBundleItems;
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }

  // Update cart UI after adding product
  async function updateCartUI() {
    try {
      // Fetch updated cart page HTML
      const pageResponse = await fetch('/cart');
      const html = await pageResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart holder (the items section)
      const currentCartHolder = $('.cart-holder');
      const newCartHolder = doc.querySelector('.cart-holder');
      if (currentCartHolder && newCartHolder) {
        currentCartHolder.innerHTML = newCartHolder.innerHTML;
      }

      // Update the entire sidebar section (includes shipping notice and total)
      const currentAside = $('aside');
      const newAside = doc.querySelector('aside');
      if (currentAside && newAside) {
        currentAside.innerHTML = newAside.innerHTML;
      }

      // Fetch cart JSON to update cart count in header
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Update cart item count in header/mini cart
      const cartCountElements = $$('[data-cart-count], .cart-count, .cart__count, #CartCount');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });

      // Trigger cart update event for other scripts
      window.dispatchEvent(new Event('cart:updated'));
      document.dispatchEvent(new Event('cart:updated'));
    } catch (error) {
      console.error('Error updating cart UI:', error);
    }
  }

  // Add product to cart
  async function addToCart(variantId, productTitle) {
    try {
      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }]
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        showToast(`${productTitle} added to cart! 🎉`);

        // Update cart UI without reloading
        await updateCartUI();
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      showToast('Unable to add product. Please try again.');
    }
  }

  // Add multiple products to cart (for 2-pack)
  async function addMultipleToCart(items, packTitle) {
    try {
      const formData = {
        items: items.map(item => ({
          id: item.variantId,
          quantity: 1
        }))
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        showToast(`${packTitle} added to cart! 🎉`);

        // Update cart UI without reloading
        await updateCartUI();
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      showToast('Unable to add products. Please try again.');
    }
  }

  // Fetch upsell products
  async function fetchUpsellProducts() {
    try {
      // Fetch both collections
      const [mungResponse, lotusResponse] = await Promise.all([
        fetch('/collections/high-protein-lentil-snacks/products.json'),
        fetch('/collections/lotus-seeds/products.json')
      ]);

      const mungData = await mungResponse.json();
      const lotusData = await lotusResponse.json();

      const allProducts = [...mungData.products, ...lotusData.products];
      const selectedProducts = [];

      // Find matching products and fetch full product data
      for (const pref of UPSELL_PRODUCTS) {
        const product = allProducts.find(p =>
          p.title.toLowerCase().includes(pref.title.toLowerCase())
        );
        if (product) {
          // Fetch full product data to get correct pricing
          try {
            const fullProductResponse = await fetch(`/products/${product.handle}.js`);
            const fullProduct = await fullProductResponse.json();
            selectedProducts.push({ product: fullProduct, badge: pref.badge });
          } catch (error) {
            console.error(`Failed to fetch full product for ${product.handle}:`, error);
            selectedProducts.push({ product, badge: pref.badge });
          }
        }
      }

      return selectedProducts;
    } catch (error) {
      console.error('Error fetching upsell products:', error);
      return [];
    }
  }

  // Render product modal
  function renderProductModal(product) {
    // Check if modal already exists
    let modal = $('#cart-upsell-modal');
    if (!modal) {
      // Create modal structure
      modal = document.createElement('div');
      modal.id = 'cart-upsell-modal';
      modal.className = 'cart-upsell-modal';
      modal.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; align-items: center; justify-content: center;';
      modal.setAttribute('data-shopify-track', 'false');
      modal.innerHTML = `
        <div class="cart-upsell-modal-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7);"></div>
        <div class="cart-upsell-modal-content" data-shopify-track="false" style="position: relative; background: #fff; border-radius: 12px; max-width: 800px; width: 90%; max-height: 90vh; overflow-y: auto; z-index: 1;"></div>
      `;
      document.body.appendChild(modal);

      // Add modal close handlers
      $('.cart-upsell-modal-overlay', modal).addEventListener('click', () => {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }

    // Helper to fix image URLs (add https: if missing)
    const fixImageUrl = (url) => {
      if (!url) return '';
      return url.startsWith('//') ? `https:${url}` : url;
    };

    // Build modal content
    const price = (product.variants[0].price / 100).toFixed(2);
    const images = (product.images || []).map(img =>
      typeof img === 'string' ? fixImageUrl(img) : fixImageUrl(img?.src || '')
    ).filter(url => url);
    const mainImage = images[0] || fixImageUrl(product.featured_image) || '';

    // Get description - try description first, then body_html
    const description = product.description || product.body_html || '';

    const modalContent = $('.cart-upsell-modal-content', modal);
    modalContent.innerHTML = `
      <div style="padding: 2rem;">
        <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 1.5rem;">
          <h2 style="font-size: 1.5rem; font-weight: 600; margin: 0;">${product.title}</h2>
          <button class="cart-upsell-modal-close" style="background: none; border: none; font-size: 2rem; cursor: pointer; padding: 0; width: 30px; height: 30px; line-height: 1; color: #666;">&times;</button>
        </div>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem;">
          <div>
            <img src="${mainImage}" alt="${product.title}" style="width: 100%; border-radius: 8px;">
            ${images.length > 1 ? `
              <div style="display: flex; gap: 0.5rem; margin-top: 1rem;">
                ${images.slice(0, 4).map((imgUrl, i) => `
                  <img src="${imgUrl}" alt="${product.title}"
                       class="cart-upsell-thumb" data-index="${i}"
                       style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer; border: 2px solid ${i === 0 ? '#97d700' : '#e5e5e5'};">
                `).join('')}
              </div>
            ` : ''}
          </div>
          <div>
            <div style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1rem;">$${price}</div>
            ${description ? `<div style="margin-bottom: 1.5rem; line-height: 1.6; color: #666;">${description}</div>` : ''}
            <button class="cart-upsell-modal-add" data-variant-id="${product.variants[0].id}" data-product-title="${product.title}" data-shopify-track="false"
                    style="width: 100%; background: #97d700; color: #000; padding: 1rem; border-radius: 6px; border: none; font-weight: 600; font-size: 1rem; cursor: pointer; transition: all 0.3s ease;">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    `;

    // Add close button handler
    $('.cart-upsell-modal-close', modal).addEventListener('click', () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });

    // Add image thumbnail handlers
    $$('.cart-upsell-thumb', modal).forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        const mainImg = modalContent.querySelector('img');
        mainImg.src = images[index];
        $$('.cart-upsell-thumb', modal).forEach((t, i) => {
          t.style.borderColor = i === index ? '#97d700' : '#e5e5e5';
        });
      });
    });

    // Add "Add to Cart" handler in modal
    $('.cart-upsell-modal-add', modal).addEventListener('click', async (e) => {
      const btn = e.target;
      const variantId = btn.dataset.variantId;
      const productTitle = btn.dataset.productTitle;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      await addToCart(variantId, productTitle);

      // Reset button before closing (in case there's a delay)
      btn.disabled = false;
      btn.textContent = 'Add to Cart';

      // Close modal after adding
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });

    // Show modal
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  // Render combo modal (for 2-pack)
  function renderComboModal(product1, product2) {
    // Check if modal already exists
    let modal = $('#cart-upsell-combo-modal');
    if (!modal) {
      // Create modal structure
      modal = document.createElement('div');
      modal.id = 'cart-upsell-combo-modal';
      modal.className = 'cart-upsell-modal';
      modal.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; align-items: center; justify-content: center;';
      modal.setAttribute('data-shopify-track', 'false');
      modal.innerHTML = `
        <div class="cart-upsell-modal-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7);"></div>
        <div class="cart-upsell-combo-modal-content" data-shopify-track="false" style="position: relative; background: #fff; border-radius: 12px; max-width: 900px; width: 95%; max-height: 90vh; overflow-y: auto; z-index: 1;"></div>
      `;
      document.body.appendChild(modal);

      // Add modal close handlers
      $('.cart-upsell-modal-overlay', modal).addEventListener('click', () => {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }

    // Helper to fix image URLs (add https: if missing)
    const fixImageUrl = (url) => {
      if (!url) return '';
      return url.startsWith('//') ? `https:${url}` : url;
    };

    // Get product details
    const price1 = (product1.variants[0].price / 100).toFixed(2);
    const price2 = (product2.variants[0].price / 100).toFixed(2);
    const totalPrice = (parseFloat(price1) + parseFloat(price2)).toFixed(2);

    const image1 = fixImageUrl(product1.images[0]?.src || product1.featured_image || '');
    const image2 = fixImageUrl(product2.images[0]?.src || product2.featured_image || '');

    const desc1 = product1.description || product1.body_html || '';
    const desc2 = product2.description || product2.body_html || '';

    const modalContent = $('.cart-upsell-combo-modal-content', modal);
    modalContent.innerHTML = `
      <div style="padding: 2rem;">
        <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 1.5rem;">
          <div>
            <div style="display: inline-block; background: #e7611f; color: white; padding: 4px 12px; border-radius: 20px; font-size: 0.75rem; font-weight: 700; margin-bottom: 0.5rem;">🎁 BEST VALUE COMBO</div>
            <h2 style="font-size: 1.5rem; font-weight: 600; margin: 0;">Crunchy Mung 2-Pack</h2>
          </div>
          <button class="cart-upsell-combo-modal-close" style="background: none; border: none; font-size: 2rem; cursor: pointer; padding: 0; width: 30px; height: 30px; line-height: 1; color: #666;">&times;</button>
        </div>

        <div class="combo-products-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; margin-bottom: 2rem;">
          <!-- Product 1 -->
          <div class="combo-product-card" style="border: 1px solid #e5e5e5; border-radius: 12px; padding: 1.5rem;">
            <img src="${image1}" alt="${product1.title}" style="width: 100%; max-height: 200px; object-fit: contain; border-radius: 8px; margin-bottom: 1rem;">
            <h3 style="font-size: 1.1rem; font-weight: 600; margin-bottom: 0.5rem;">${product1.title}</h3>
            <div style="font-size: 1.25rem; font-weight: 700; color: #e7611f; margin-bottom: 0.75rem;">$${price1}</div>
            ${desc1 ? `<div style="font-size: 0.9rem; line-height: 1.5; color: #666; max-height: 100px; overflow-y: auto;">${desc1}</div>` : ''}
          </div>

          <!-- Product 2 -->
          <div class="combo-product-card" style="border: 1px solid #e5e5e5; border-radius: 12px; padding: 1.5rem;">
            <img src="${image2}" alt="${product2.title}" style="width: 100%; max-height: 200px; object-fit: contain; border-radius: 8px; margin-bottom: 1rem;">
            <h3 style="font-size: 1.1rem; font-weight: 600; margin-bottom: 0.5rem;">${product2.title}</h3>
            <div style="font-size: 1.25rem; font-weight: 700; color: #e7611f; margin-bottom: 0.75rem;">$${price2}</div>
            ${desc2 ? `<div style="font-size: 0.9rem; line-height: 1.5; color: #666; max-height: 100px; overflow-y: auto;">${desc2}</div>` : ''}
          </div>
        </div>

        <!-- Combined pricing and add to cart -->
        <div style="background: linear-gradient(135deg, #fffbf0 0%, #ecfdf5 100%); border: 2px solid #e7611f; border-radius: 12px; padding: 1.5rem; text-align: center;">
          <div style="display: flex; justify-content: center; align-items: center; gap: 1rem; margin-bottom: 1rem; flex-wrap: wrap;">
            <span style="font-size: 1rem; color: #666;">2-Pack Total:</span>
            <span style="font-size: 1.75rem; font-weight: 700; color: #e7611f;">$${totalPrice}</span>
          </div>
          <button
            class="cart-upsell-combo-modal-add"
            data-variant1="${product1.variants[0].id}"
            data-variant2="${product2.variants[0].id}"
            data-shopify-track="false"
            style="background: #e7611f; color: #fff; padding: 1rem 3rem; border-radius: 8px; border: 2px solid #e7611f; font-weight: 600; font-size: 1.1rem; cursor: pointer; transition: all 0.3s ease;">
            Add Both to Cart
          </button>
          <div style="margin-top: 0.75rem; font-size: 0.85rem; color: #e7611f; font-weight: 500;">🔥 Most Popular Combo - Get both flavors!</div>
        </div>
      </div>

      <style>
        .cart-upsell-combo-modal-add:hover {
          background: #fff !important;
          color: #e7611f !important;
          border-color: #e7611f !important;
          transform: scale(1.02);
        }
        @media (max-width: 600px) {
          .cart-upsell-combo-modal-content {
            width: 100% !important;
            max-width: 100% !important;
            max-height: 100vh !important;
            border-radius: 0 !important;
          }
          .cart-upsell-combo-modal-content > div {
            padding: 1rem !important;
          }
          .cart-upsell-combo-modal-content h2 {
            font-size: 1.25rem !important;
          }
          .combo-products-grid {
            grid-template-columns: 1fr !important;
            gap: 1rem !important;
          }
          .combo-product-card {
            padding: 1rem !important;
          }
          .combo-product-card img {
            max-height: 150px !important;
          }
          .cart-upsell-combo-modal-add {
            width: 100% !important;
            padding: 1rem !important;
          }
        }
      </style>
    `;

    // Add close button handler
    $('.cart-upsell-combo-modal-close', modal).addEventListener('click', () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });

    // Add "Add Both to Cart" handler
    $('.cart-upsell-combo-modal-add', modal).addEventListener('click', async (e) => {
      const btn = e.target;
      const variantId1 = btn.dataset.variant1;
      const variantId2 = btn.dataset.variant2;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      await addMultipleToCart([
        { variantId: variantId1 },
        { variantId: variantId2 }
      ], 'Crunchy Mung 2-Pack');

      // Reset button before closing
      btn.disabled = false;
      btn.textContent = 'Add Both to Cart';

      // Close modal after adding
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });

    // Show modal
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  // Render upsell section
  function renderUpsellSection(products) {
    const cartForm = $('form[action="/cart"]') || $('.cart') || $('main');
    if (!cartForm) return;

    // Check if section already exists
    if ($('.cart-upsell-section')) return;

    // Store products for modal access
    window.cartUpsellProducts = products;

    // Create 2-pack from first two products (Crunchy Mung Snacks)
    const twoPackProducts = products.slice(0, 2);
    const hasTwoPack = twoPackProducts.length === 2;
    let twoPackHtml = '';

    if (hasTwoPack) {
      const product1 = twoPackProducts[0].product;
      const product2 = twoPackProducts[1].product;
      const price1 = product1.variants[0].price / 100;
      const price2 = product2.variants[0].price / 100;
      const totalPrice = (price1 + price2).toFixed(2);
      const imageUrl1 = product1.images[0]?.src || product1.featured_image || '';
      const imageUrl2 = product2.images[0]?.src || product2.featured_image || '';

      twoPackHtml = `
        <div class="cart-upsell-card cart-upsell-2pack" data-is2pack="true" data-shopify-track="false" style="min-width: calc(33.333% - 1rem); border: 2px solid #e7611f; border-radius: 12px; padding: 1.5rem; text-align: center; transition: all 0.3s ease; background: linear-gradient(135deg, #fffbf0 0%, #fff 100%); flex-shrink: 0; cursor: pointer; position: relative;">
          <div style="position: absolute; top: 8px; left: 50%; transform: translateX(-50%); background: #e7611f; color: white; padding: 4px 12px; border-radius: 20px; font-size: 0.7rem; font-weight: 700; white-space: nowrap; z-index: 1;">🎁 BEST VALUE</div>
          <div style="display: flex; justify-content: center; gap: 4px; height: 150px; margin: 1.5rem auto 1rem; max-width: 150px;">
            <img src="${imageUrl1}" alt="${product1.title}" style="width: 50%; height: 150px; object-fit: cover; border-radius: 8px 0 0 8px;">
            <img src="${imageUrl2}" alt="${product2.title}" style="width: 50%; height: 150px; object-fit: cover; border-radius: 0 8px 8px 0;">
          </div>
          <h3 style="font-size: 1rem; margin-bottom: 0.5rem; font-weight: 600; line-height: 1.3;">Crunchy Mung 2-Pack</h3>
          <div style="font-size: 1.1rem; font-weight: 700; color: #000; margin-bottom: 1rem;">$${totalPrice}</div>
          <button
            class="cart-upsell-btn cart-upsell-2pack-btn"
            data-variant1="${product1.variants[0].id}"
            data-variant2="${product2.variants[0].id}"
            data-shopify-track="false"
            style="width: 100%; background: #e7611f; color: #fff; padding: 0.75rem; border-radius: 6px; border: 2px solid #e7611f; font-weight: 600; cursor: pointer; transition: all 0.3s ease;">
            Add Both to Cart
          </button>
          <div style="margin-top: 0.5rem; font-size: 0.8rem; color: #e7611f; font-weight: 600;">🔥 Most Popular Combo</div>
        </div>
      `;
    }

    // Create section
    const section = document.createElement('div');
    section.className = 'cart-upsell-section';
    section.style.cssText = 'padding: 2rem 0; margin: 2rem 0; border-top: 1px solid #e5e5e5;';
    section.setAttribute('data-shopify-track', 'false');

    section.innerHTML = `
      <h2 style="text-align: center; font-size: 1.5rem; margin-bottom: 0.5rem; font-weight: 600;">Customers also bought</h2>
      <p style="text-align: center; color: #666; margin-bottom: 2rem;">Pair these with your bundle:</p>

      <div style="position: relative; max-width: 1000px; margin: 0 auto; padding: 0 50px;">
        <button class="cart-upsell-prev" style="position: absolute; left: 0; top: 50%; transform: translateY(-50%); background: #fff; border: 2px solid #e5e5e5; border-radius: 50%; width: 40px; height: 40px; cursor: pointer; z-index: 10; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; color: #333; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">‹</button>
        <button class="cart-upsell-next" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); background: #fff; border: 2px solid #e5e5e5; border-radius: 50%; width: 40px; height: 40px; cursor: pointer; z-index: 10; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; color: #333; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">›</button>

        <div class="cart-upsell-carousel" style="overflow: hidden;">
          <div class="cart-upsell-grid" style="display: flex; transition: transform 0.3s ease; gap: 1.5rem;">
            ${twoPackHtml}
            ${products.map(({ product, badge }, index) => {
              const price = (product.variants[0].price / 100).toFixed(2);
              const imageUrl = product.images[0]?.src || product.featured_image || '';

              return `
                <div class="cart-upsell-card" data-product-index="${index}" data-shopify-track="false" style="min-width: calc(33.333% - 1rem); border: 2px solid #e5e5e5; border-radius: 12px; padding: 1.5rem; text-align: center; transition: all 0.3s ease; background: #fff; flex-shrink: 0; cursor: pointer;">
                  <img src="${imageUrl}" alt="${product.title}" style="width: 100%; max-width: 150px; height: 150px; object-fit: cover; border-radius: 8px; margin: 0 auto 1rem; display: block;">
                  <h3 style="font-size: 1rem; margin-bottom: 0.5rem; font-weight: 600; line-height: 1.3;">${product.title}</h3>
                  <div style="font-size: 1.1rem; font-weight: 700; color: #000; margin-bottom: 1rem;">$${price}</div>
                  <button
                    class="cart-upsell-btn"
                    data-variant-id="${product.variants[0].id}"
                    data-product-title="${product.title}"
                    data-shopify-track="false"
                    style="width: 100%; background: #e7611f; color: #fff; padding: 0.75rem; border-radius: 6px; border: 2px solid #e7611f; font-weight: 600; cursor: pointer; transition: all 0.3s ease;">
                    Add to Cart
                  </button>
                  <div style="margin-top: 0.5rem; font-size: 0.8rem; color: #999;">${badge}</div>
                </div>
              `;
            }).join('')}
          </div>
        </div>
      </div>
    `;

    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      .cart-upsell-card:hover {
        border-color: #e7611f;
        box-shadow: 0 4px 12px rgba(4, 120, 87, 0.2);
        transform: translateY(-2px);
      }
      .cart-upsell-2pack:hover {
        border-color: #d15519;
        box-shadow: 0 4px 16px rgba(4, 120, 87, 0.3);
        transform: translateY(-2px);
      }
      .cart-upsell-btn:hover {
        background: #fff !important;
        color: #e7611f !important;
        border: 2px solid #e7611f !important;
        transform: scale(1.02);
      }
      .cart-upsell-2pack-btn:hover {
        background: #fff !important;
        color: #e7611f !important;
        border: 2px solid #e7611f !important;
      }
      .cart-upsell-btn:disabled {
        background: #ccc;
        cursor: not-allowed;
        transform: none;
      }
      .cart-upsell-prev:hover, .cart-upsell-next:hover {
        background: #f5f5f5;
        border-color: #e7611f;
      }
      @media (max-width: 768px) {
        .cart-upsell-card {
          min-width: 100% !important;
        }
        .cart-upsell-section > div {
          padding: 0 50px !important;
        }
      }
    `;
    document.head.appendChild(style);

    // Insert before checkout button or at end of cart
    const checkoutBtn = $('[name="checkout"]') || $('.cart__checkout');
    if (checkoutBtn && checkoutBtn.closest('.cart__footer')) {
      checkoutBtn.closest('.cart__footer').insertAdjacentElement('beforebegin', section);
    } else {
      cartForm.appendChild(section);
    }

    // Initialize carousel (add 1 for the 2-pack card if it exists)
    const totalCards = hasTwoPack ? products.length + 1 : products.length;
    initializeCarousel(section, totalCards);

    // Add click handlers for cards (view product details)
    $$('.cart-upsell-card', section).forEach(card => {
      card.addEventListener('click', (e) => {
        // Don't open modal if clicking the button
        if (e.target.closest('.cart-upsell-btn')) return;

        // Check if this is a 2-pack card - show combo modal
        if (card.dataset.is2pack === 'true') {
          const twoPackProducts = window.cartUpsellProducts.slice(0, 2);
          if (twoPackProducts.length === 2) {
            renderComboModal(twoPackProducts[0].product, twoPackProducts[1].product);
          }
          return;
        }

        const productIndex = parseInt(card.dataset.productIndex);
        const productData = window.cartUpsellProducts[productIndex];
        if (productData) {
          renderProductModal(productData.product);
        }
      });
    });

    // Add click handler for 2-pack button
    const twoPackBtn = $('.cart-upsell-2pack-btn', section);
    if (twoPackBtn) {
      twoPackBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId1 = twoPackBtn.dataset.variant1;
        const variantId2 = twoPackBtn.dataset.variant2;
        const originalText = twoPackBtn.textContent;

        twoPackBtn.disabled = true;
        twoPackBtn.textContent = 'Adding...';

        await addMultipleToCart([
          { variantId: variantId1 },
          { variantId: variantId2 }
        ], 'Crunchy Mung 2-Pack');

        // Reset button state after adding
        twoPackBtn.disabled = false;
        twoPackBtn.textContent = originalText;
      });
    }

    // Add click handlers for buttons (add to cart)
    $$('.cart-upsell-btn:not(.cart-upsell-2pack-btn)', section).forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent card click event

        const variantId = btn.dataset.variantId;
        const productTitle = btn.dataset.productTitle;
        const originalText = btn.textContent;

        btn.disabled = true;
        btn.textContent = 'Adding...';

        await addToCart(variantId, productTitle);

        // Reset button state after adding
        btn.disabled = false;
        btn.textContent = originalText;
      });
    });
  }

  // Initialize carousel navigation
  function initializeCarousel(section, totalProducts) {
    let currentIndex = 0;
    const grid = $('.cart-upsell-grid', section);
    const prevBtn = $('.cart-upsell-prev', section);
    const nextBtn = $('.cart-upsell-next', section);
    const cards = $$('.cart-upsell-card', section);
    const carousel = $('.cart-upsell-carousel', section);

    if (!grid || !prevBtn || !nextBtn || !cards.length || !carousel) return;

    function updateCarousel() {
      const isMobile = window.innerWidth <= 768;
      const containerWidth = carousel.offsetWidth;
      const cardWidth = cards[0].offsetWidth;
      const gap = 24; // 1.5rem

      // Calculate how many products actually fit in the visible area
      const actuallyFits = Math.floor(containerWidth / (cardWidth + gap));
      const visibleProducts = isMobile ? 1 : Math.max(1, actuallyFits);
      const maxIndex = Math.max(0, totalProducts - visibleProducts);

      // Clamp current index
      currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

      let offset;
      if (currentIndex >= maxIndex && maxIndex > 0) {
        // At the end, ensure the last card is fully visible
        // Get the actual position of the last card
        const lastCard = cards[totalProducts - 1];
        const lastCardRight = lastCard.offsetLeft + lastCard.offsetWidth;
        // Calculate offset to align the last card's right edge with container's right edge
        offset = Math.max(0, lastCardRight - containerWidth);
      } else {
        // Normal scrolling by card index
        offset = currentIndex * (cardWidth + gap);
      }

      grid.style.transform = `translateX(-${offset}px)`;

      // Update button states
      prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
      prevBtn.style.cursor = currentIndex === 0 ? 'not-allowed' : 'pointer';
      prevBtn.disabled = currentIndex === 0;
      nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
      nextBtn.style.cursor = currentIndex >= maxIndex ? 'not-allowed' : 'pointer';
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    // Previous button click handler
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    // Next button click handler
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isMobile = window.innerWidth <= 768;
      const containerWidth = carousel.offsetWidth;
      const cardWidth = cards[0].offsetWidth;
      const gap = 24;
      const actuallyFits = Math.floor(containerWidth / (cardWidth + gap));
      const visibleProducts = isMobile ? 1 : Math.max(1, actuallyFits);
      const maxIndex = totalProducts - visibleProducts;
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    });

    // Update on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        currentIndex = 0;
        updateCarousel();
      }, 150);
    });

    // Initial update
    updateCarousel();
  }

  // Initialize
  async function init() {
    // Check if we should show upsells
    const show = await shouldShowUpsells();
    if (!show) return;

    // Fetch and render products
    const products = await fetchUpsellProducts();
    if (products.length > 0) {
      renderUpsellSection(products);
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
